import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 200px;
  background-color: var(--grey-section-bg);
  padding: 30px 10px;
  img {
    mix-blend-mode: multiply;
    max-width: 165px;
    margin: 0 8px;
  }
  @media only screen and (max-width: 540px) {
    img {
      max-width: 90px;
    }
  }
`

const Sponsors = ({ sponsors }) => (
  <Wrapper>
    {/** biome-ignore lint/correctness/noUnusedFunctionParameters: TODO */}
    {Object.keys(sponsors).map((id, i) => (
      <img src={sponsors[id]} alt={id} key={id} />
    ))}
  </Wrapper>
)

export default Sponsors
